export const API_URL = "https://suggestcrm.com";
// export const API_URL = "http://192.168.30.53:8000";
// export const API_URL = "http://localhost:8000";
